import { AxiosResponse } from "axios";
import { Material } from "../models/Material";
import { SERVERURL } from "../globals/constants";
import { Profile } from "../models/Profile";
import axios from "./axiosConfig";

export const getAllMaterials = async (user: Profile) => {
  const { data } = await axios.get<Material[]>(`${SERVERURL}/material/getall`, {
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  return data;
};

export const createMaterial = async (
  user: Profile,
  material: Material
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.post(
      `${SERVERURL}/material/create`,
      material,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const updateMaterial = async (
  user: Profile,
  material: Material,
  materialId: number
): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.put(
      `${SERVERURL}/material/update/${materialId}`,
      material,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};

export const deleteMaterial = async (user: Profile, materialId: number) => {
  try {
    const response: AxiosResponse = await axios.delete(
      `${SERVERURL}/material/remove/${materialId}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
